module.exports = __webpack_public_path__ + "static/media/inspirational_1.139ec5c5.svg";